import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackClarityEvent } from "./ClarityAnalytics";
import { CLARITY_EVENTS } from "./EventTypes";

export const useClarityPageView = () => {
    const location = useLocation();

    useEffect(() => {
        
        trackClarityEvent(CLARITY_EVENTS.PAGE_VIEW, {
            path: location.pathname,
        });
    }, [location.pathname]);
};
